























import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import addRoutes from "@root/lib/addRoutes";
import router from "@root/router";
const Root = namespace("root");
@Component({})
export default class NewLoginType extends Vue {
  @Root.Action queryDataDictionaryListLang;
  @Root.Action menuListByRole;
  typeList: any = [];
  textList: any = [];
  get labelMaps() {
    let result: any = {};
    this.textList.forEach(_ => {
      result[_.value] = _.label;
    });
    return result;
  }
  async created() {
    let list = JSON.parse(sessionStorage.getItem("loginTypeList") || "[]");
    if (list.length > 0) {
      sessionStorage.setItem("accessLogin", "1");
    }
    if (list.length > 1) {
      this.typeList = list;
      let res = await this.queryDataDictionaryListLang({
        input: {
          ddCode: "MASTER_KONE_MEMBER_TYPE"
        }
      });
      this.textList = res;
    } else {
      this.goLogin();
    }
  }
  goLogin() {
    this.$router.push({
      name: "Login"
    });
    sessionStorage.removeItem("accessLogin");
  }
  menuList: any = [];
  // 获取菜单
  async getMenuList(roleCode) {
    let res = await this.menuListByRole({
      roleCode
    });
    this.menuList = res || [];
  }
  async goApp(item) {
    let {
      marketType,
      memberType,
      memberName,
      memberCode,
      roleCode,
      oaStatus,
      status
    } = item;
    await this.getMenuList(roleCode);
    if (!this.menuList || this.menuList.length === 0) {
      // this.$router.push({ name: "Login" });
      this.$message.warning("当前用户无任何菜单，请联系管理员！");
      this.goLogin();
      return;
    } else {
      addRoutes(router);
    }
    localStorage.setItem("marketType", marketType);
    localStorage.setItem("memberType", memberType);
    localStorage.setItem("memberName", memberName);
    localStorage.setItem("memberCode", memberCode);
    localStorage.setItem("menuRoleCode", roleCode || "");
    localStorage.setItem("loginTypeList", JSON.stringify(this.typeList));

    let isOaCooperation: any = (oaStatus || status) === "11" ? "11" : "";
    localStorage.setItem("oaStatus", oaStatus || status);
    localStorage.setItem("isOaCooperation", isOaCooperation);
    // 根据 isOaCooperation 来判断账号的oa合作状态，非合作状态只有搜索和导出的权限

    this.$router.push("/");
  }
  destroyed() {
    sessionStorage.removeItem("loginTypeList");
    sessionStorage.removeItem("accessLogin");
  }
}
